import { css, cx } from 'styled-system/css';
import { planColumnBorderLeft } from './PlanColumn';

export function AdditionalUsage() {
  return (
    <div
      className={css({
        gridColumn: '1 / -1',
        display: 'grid',
        gridTemplateColumns: { base: '1fr', md: 'repeat(3, minmax(0, 1fr))' },
        rowGap: '2',
        paddingBlock: { base: '5', md: '6' },
        borderTop: '1px solid token(colors.border.hairline)',
        background: 'bg.sunken',
      })}
    >
      <h2
        className={css({
          paddingInline: { base: '6', md: '8' },
          fontFamily: 'sans',
          fontSize: 'sm',
          fontWeight: 'semibold',
          lineHeight: 'relaxed',
          margin: '0',
        })}
      >
        Additional usage
      </h2>
      <p
        className={cx(
          planColumnBorderLeft(),
          css({
            gridColumn: { md: 'span 2' },
            paddingInline: { base: '6', md: '8' },
            fontSize: 'sm',
            lineHeight: 'relaxed',
            color: 'text.secondary',
            textWrap: 'pretty',
          }),
        )}
      >
        On Pro, past 10,000 in a month, opt in to keep going at{' '}
        <strong
          className={css({ fontWeight: 'semibold', color: 'text.primary' })}
        >
          $0.005 per cell edit
        </strong>
        , with a hard stop at 100,000. Starter has no extra-cell charge: it
        stops at 5,000. Unused edits do not roll over.
      </p>
    </div>
  );
}
